export default __webpack_public_path__ + "static/media/TeoUrsu.699c179e.jpg";